import { ColorAttribute, getAttributesToSerialize } from '../attributes';
import { TimeInvariantBase } from '../TimeInvariantBase';

export class ColorMap extends TimeInvariantBase {
    override _name = 'ColorMap';
    override _classType = 'ColorMap';

    @ColorAttribute()
    accessor sourceColor: number = 0x000000;

    @ColorAttribute()
    accessor targetColor: number = 0x000000;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-useless-constructor
    constructor(settings: any) {
        super(settings);
    }

    override get readonlyProperties(): string[] {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    }
}
